<template>
    <div id="transferExcel">
        <a-modal
            title="Transfer Excel"
            :visible="visible"
            :footer="null"
            @cancel="() => (visible = false)"
        >
            <a-upload
                    :showUploadList="false"
                    :customRequest="customRequest"
                    :headers="headers"
                    :data="uploadData"
                    method="post"
            >
                <a-tooltip placement="topLeft">
                    <template slot="title">
                        <span>Upload</span>
                    </template>
                    <a-button type="primary" shape="circle" icon="upload" size="small"/>
                </a-tooltip>
            </a-upload>
            <a-tooltip placement="topLeft">
                <template slot="title">
                    <span>Download</span>
                </template>
                <a-button  type="primary" shape="circle" icon="download" size="small" @click='downloadTml' class="ml4"/>
            </a-tooltip>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import axios from 'axios'
    import cookie from "../../../api/cookie";
    export default{
        data(){
            return{
                visible: false,
                headers: {
                    "Authorization": cookie.getToken()
                },
                uploadData:{}
            }
        },
        methods:{
            show(){
               this.visible = true
            },
            customRequest(data){
                const formData = new FormData()
                formData.append('file', data.file)
                this.$store.commit("updataLoading", { pbLoading: true });
                ajax.post(api.INVENTORYIMPORTTRANSFEREXCEL,formData).then(res=>{
                    this.$store.commit("updataLoading", { pbLoading: false });
                    if(res.code == '200'){
                        this.$message.success(res.msg);
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            downloadTml(){
                let ajaxurl = ajax.ajaxUrl();
                axios.get(ajaxurl + api.INVENTORYEXPORTTRANSFEREXCEL, {
                    params: {},
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(res=>{
                    this.$store.commit("updataLoading", { pbLoading: false });
                    let blob = new Blob([res.data], {type: "application/octet-stream;charset=UTF-8"});
                    let url = window.URL.createObjectURL(blob);
                    let aLink = document.createElement("a");
                    aLink.style.display = "none";
                    aLink.href = url;
                    aLink.setAttribute("download", 'excel.xlsx');
                    document.body.appendChild(aLink);
                    aLink.click();
                    document.body.removeChild(aLink); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                })
            }
        }
    }
</script>